
export const handleValidation = (rawInput: any) => {
    if (rawInput.basic.value == "") {
        rawInput.basic.error = "Please enter basic salary";
    
      }
  if (rawInput.HRA.value == "") {
    rawInput.HRA.error = "Please enter hra";

  }
  // if (rawInput.medical_allowance.value == "") {
  //   rawInput.medical_allowance.error = "please enter medical allowance";

  // }
  // if (rawInput.conbeyance_allowance.value == "") {
  //   rawInput.conbeyance_allowance.error = "please enter conbeyance allowance";

  // }
  // if (rawInput.special_allowance.value == "") {
  //   rawInput.special_allowance.error = "please enter special allowance";

  // }
  // if (rawInput.others.value == "") {
  //   rawInput.others.error = "please enter others allowance";

  // }

  return rawInput;
};
export const initialState = (inputResponse: any, isEdit = false) => {
    return {
      HRA: { value: inputResponse.HRA ?? "", error: "" },
      basic: { value: inputResponse.basic ?? "", error: "" },
      medical_allowance: { value: inputResponse.medical_allowance ?? "", error: "" },
      conbeyance_allowance: { value: inputResponse.conbeyance_allowance ?? "", error: "" },
      special_allowance: { value: inputResponse.special_allowance ?? "", error: "" },
      others: { value: inputResponse.others ?? "", error: "" },
      _id: { value: inputResponse._id ?? "", error: "" },

    };
  };

